import { DocumentViewItem, IDocumentViewItem } from "./documentViewItem";

export interface IDocumentView {
    item: IDocumentViewItem;
}

export class DocumentView implements IDocumentView {
    item: DocumentViewItem;

    constructor();
    constructor(obj: IDocumentView);
    constructor(obj?: any) {
        this.item = null;
        if (obj && obj.item) {
            this.item = new DocumentViewItem(obj.item);
        }
    }
}